import { Injectable } from '@angular/core';

import { BetSlipType as BposBetSlipType } from '@bpos';

import { BetslipType } from '../../../../../core/betslip-type';
import { getPicksCount } from '../../../../../core/utils';
import { CriteriaType, IRewardToken } from '../../../reward-tokens.model';
import { TokenValidationInput, TokensCriteriaValidatorBase } from '../criteria-validator-base.service';

@Injectable()
export class MinimumLegsValidator extends TokensCriteriaValidatorBase<IRewardToken, CriteriaType> {
    override type = CriteriaType.MinimumLegs;

    isValid(token: IRewardToken, state: TokenValidationInput): boolean {
        const picksCount = getPicksCount(state.selectedPicks);

        const isTokenAvailableForComboBet = token.filter?.betSlipType === BposBetSlipType.Combo || token.isSingleAndComboSelected;
        const isMinimumLegsBetType =
            state.selectedType === BetslipType.Combo || state.selectedType === BetslipType.Teaser || state.selectedType === BetslipType.BetBuilder;

        /**
         * Minimum legs validation only performed for Combo / Teaser / BetBuilder bet and in Single Bet mode it is simply ignored.
         * e.g. token with "Bet Type: Any" and "Min. Legs: 2" can be applied to a single bet (1 leg) and placed successfully.
         */
        if (isTokenAvailableForComboBet && isMinimumLegsBetType) {
            return token.minimumLegs ? picksCount >= token.minimumLegs : true;
        }

        return true;
    }
}
